
import { Component, Vue, Prop, Watch } from 'vue-property-decorator'

@Component
export default class Price extends Vue {
  @Prop({ default: '¥' }) unit!: string // 单位
  @Prop({ default: '0' }) value!: string | number // 数值
  @Prop({ default: '#f12b2b' }) color!: string // 字色
  @Prop({ default: 'bold' }) unitWeight!: string | number // 单位字重
  @Prop({ default: 'bolder' }) integerWeight!: string | number // 整数字重
  @Prop({ default: 'bold' }) decimalWeight!: string | number // 小数字重
  @Prop({ default: 12 }) unitSize!: number // 单位字号
  @Prop({ default: 18 }) integerSize!: number // 整数字号
  @Prop({ default: 12 }) decimalSize!: number // 小数字号

  integer = 0
  decimal = '00'

  @Watch('value', { immediate: true })
  onChangeValue(newVal) {
    console.log(newVal)
    const valueArr = newVal.toString().split('.')
    this.decimal = (valueArr[1] || '00').trim()
    this.integer = (
      valueArr[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',') || '0'
    ).trim()
  }
}
